
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"14","viewBox":"0 0 512.001 512","width":"14","xmlns":"http://www.w3.org/2000/svg","fill":"#333"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M456.883 0H262.574a15.003 15.003 0 00-10.605 4.395L16.113 240.242c-21.484 21.492-21.484 56.457 0 77.942l177.7 177.695c10.374 10.375 24.214 16.09 38.964 16.094h.004c14.754 0 28.594-5.72 38.973-16.098l235.848-235.852a15.003 15.003 0 004.394-10.605L512 55.109C511.996 24.723 487.27 0 456.883 0zm25.113 243.207L250.54 474.664c-4.71 4.715-11.02 7.309-17.758 7.309-6.742 0-13.047-2.594-17.758-7.305L37.324 296.973c-9.789-9.79-9.789-25.727 0-35.52L268.785 30h188.098C470.73 30 482 41.266 482 55.113zm0 0"}}),_c('path',{attrs:{"d":"M379.785 85.078c-12.59 0-24.426 4.906-33.328 13.809-8.902 8.898-13.805 20.734-13.805 33.324 0 12.59 4.903 24.426 13.805 33.328 8.902 8.902 20.738 13.805 33.328 13.805 12.586 0 24.422-4.903 33.324-13.805 8.903-8.902 13.805-20.738 13.805-33.328 0-12.59-4.902-24.426-13.8-33.324-8.903-8.903-20.739-13.809-33.329-13.809zm12.113 59.246a17.01 17.01 0 01-12.113 5.02 17.003 17.003 0 01-12.113-5.02 17.01 17.01 0 01-5.02-12.113 17.01 17.01 0 015.02-12.113 17.01 17.01 0 0112.113-5.02c4.574 0 8.875 1.781 12.113 5.02a17.01 17.01 0 015.02 12.113c0 4.574-1.785 8.879-5.02 12.113zm0 0"}})])
          )
        }
      }
    